module.exports = __webpack_public_path__ + "img/main_technic_4.6a00a3e5.jpg";